import { Component, inject } from '@angular/core';
import { table, CacTableComponent } from '@controladad/ng-base';
import { AuthStore, cacTableIdCol, cacTableStatusCol, UserApiService } from '@core';
import { UserEntity } from '@models';

@Component({
  selector: 'lib-customer-users',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './customer-users.component.html',
  styleUrl: './customer-users.component.scss',
})
export class CustomerUsersComponent {
  private readonly usersApi = inject(UserApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.usersApi.getCustomerAdapter(),
    selectable: true,
    view: {
      itemName: 'Customer',
      title: 'Customer',
    },
    columns: {
      id: cacTableIdCol(),
      email: {
        label: 'Email',
        sortable: true,
        filterable: true,
      },
      fullName: {
        label: 'Full Name',
        sortable: 'FullName',
        filterable: 'FullName',
        // transform: (_, row) => getFullName(row),
      },
      phoneNumber: {
        label: 'Phone Number',
        sortable: true,
        filterable: [
          {
            type: 'contains',
            key: 'PhoneNumber',
            inputType: 'number-nobtn',
          },
        ],
      },
      status: cacTableStatusCol(),
      createdAt: {
        label: 'Created At',
        sortable: true,
        filterable: [
          { type: 'greater', controlType: 'datetime', key: 'CreatedAtFrom' },
          { type: 'lower', controlType: 'datetime', key: 'CreatedAtTo' },
        ],
        type: 'datetime',
      },
    },

    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item) => dialog$.customerUser({ user: item }).afterSubmit(),
      },
    ],
    bulkActions: [
      ...(!this.authStore.isRestrictedAdmin() ? [{
        content: 'Delete',
        action: (items: UserEntity[]) =>
          dialog$
            .deletePrompt(true, { itemName: `Users ${items.map((u) => u.id).join(', ')}` })
            .action(() => this.usersApi.delete({ userIds: items.map((i) => i.id) })),
      }] : []),
      {
        content: 'Active',
        action: (items) =>
          dialog$
            .prompt({
              title: 'Are you sure you want to Activate the selected users?',
              yesButtonText: 'Yes, Activate',
              message: 'This action will Activate the selected users.',
            })
            .action(() => this.usersApi.changeStatus({ ids: items.map((i) => i.id), status: 1 })),
      },
      {
        content: 'Deactive',
        action: (items) =>
          dialog$
            .prompt({
              title: 'Are you sure you want to Deactivate the selected users?',
              yesButtonText: 'Yes, Deactivate',
              message: 'This action will Deactivate the selected users.',
            })
            .action(() => this.usersApi.changeStatus({ ids: items.map((i) => i.id), status: 0 })),
      },
    ],
    events: {
      add: () => dialog$.customerUser({}).afterSubmit(),
    },
  });
}
